//
export default [
    {
        field       : 'period',
        flex : {
            xs12    : true,
            sm8     : true, 
            'px-2'  : true,           
        },
        type        : 'datePicker',
        pickerProps : {
            type    : 'month',
        },
        vuetifyProps: {
            label   : 'Periodo',
        },
        rules       : [ 'required'],
        value       : '',
    },
]